import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';
function KeywordSearchInput(_ref) {
  var name = _ref.name,
    submenuTitle = _ref.submenuTitle,
    selectionData = _ref.selectionData,
    handleChange = _ref.handleChange,
    setSelectionState = _ref.setSelectionState;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "subcontent-title"
  }, submenuTitle === 'Role' && 'Search by', ' ', submenuTitle), /*#__PURE__*/React.createElement("div", {
    className: "keyword-search-container"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    placeholder: "Type ".concat(submenuTitle, "s"),
    value: selectionData[name][submenuTitle] || '',
    onChange: function onChange(event) {
      if (selectionData[name][submenuTitle] && selectionData[name][submenuTitle].length >= 2) {
        analyticsTrack("Filtered by ".concat(submenuTitle), {
          location: 'Search Index'
        });
      }
      handleChange(name, submenuTitle, event.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        setSelectionState(selectionData);
      }
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: function onClick() {
      return setSelectionState(selectionData);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-search"
  }))));
}
KeywordSearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  submenuTitle: PropTypes.string.isRequired,
  selectionData: PropTypes.instanceOf({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  setSelectionState: PropTypes.func.isRequired
};
export default KeywordSearchInput;